export const templesGroup3 = [
  {
    slNo: "26",
    slug: "badrinath-temple",
    generalInfo: {
      templeName: "Shri Badrinath Temple",
      templeDescription: "Badrinath Temple is one of the Char Dham shrines and is dedicated to Lord Badri Vishal, a form of Vishnu. The temple stands in the upper Alaknanda valley and operates only during the Himalayan pilgrimage season, closing for winter. In 2026 Char Dham registration is mandatory. Unlike Kedarnath, the shrine can be reached by motorable road, although altitude and cold weather still require preparation. Pilgrims often visit Tapt Kund before darshan and combine the trip with Mana, Brahma Kapal and other nearby sacred sites.",
      location: "Badrinath, Chamoli, Uttarakhand",
      deity: "Lord Badri Vishal (Vishnu)",
      trekPoints: [],
      dressCode: "Warm layered clothing and modest temple attire; weather can be cold even in summer."
    },
    timeInfo: {
      bestTime: "May - June and September - October",
      peakTime: "Opening weeks, May-June and festival/holiday periods"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [
      {
        name: "Char Dham Yatra Registration",
        description: "Mandatory registration for Badrinath yatra in 2026.",
        isMandatory: true,
        method: "Online / App / Authorized Onsite Counters",
        cost: "Free",
        requiredDocs: "Valid government photo ID",
        location: "Char Dham registration system",
        website: "https://registrationandtouristcare.uk.gov.in/",
        validity: "For registered yatra/date rules"
      }
    ],
    prerequisites: [
      { name: "Altitude & Weather", description: "Carry Char Dham registration and valid ID; carry warm clothing and medicines." }
    ],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "-7", low: "-14" },
        { month: "Feb", high: "-6", low: "-13" },
        { month: "Mar", high: "-3", low: "-11" },
        { month: "Apr", high: "1", low: "-8" },
        { month: "May", high: "5", low: "-4" },
        { month: "Jun", high: "9", low: "1" },
        { month: "Jul", high: "11", low: "5" },
        { month: "Aug", high: "11", low: "6" },
        { month: "Sep", high: "9", low: "2" },
        { month: "Oct", high: "4", low: "-3" },
        { month: "Nov", high: "0", low: "-8" },
        { month: "Dec", high: "-5", low: "-12" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "06:30 AM",
        morningClose: "02:00 PM",
        eveningOpen: "03:00 PM",
        eveningClose: "09:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Mahabhishek / Abhishek", time: "Approx. 04:30 AM - 06:30 AM" },
        { name: "Day Pujas", time: "07:30 AM - 12:00 PM; 03:00 PM - 06:00 PM" },
        { name: "Evening Aartis", time: "Approx. 06:00 PM - 07:45 PM" }
      ]
    },
    transportation: [
      { mode: "Road", startPoint: "Jolly Grant Airport, Dehradun", endPoint: "Badrinath", distanceKm: 306, duration: "Approx. 8-10 hrs", cost: "N/A" },
      { mode: "Road / Bus", startPoint: "Rishikesh", endPoint: "Badrinath", distanceKm: 294, duration: "Approx. 8-10 hrs", cost: "N/A" },
      { mode: "Local Road", startPoint: "Joshimath", endPoint: "Badrinath", distanceKm: 45, duration: "Approx. 1.5-2 hrs", cost: "N/A" }
    ],
    accommodation: [
      { type: "BKTC Guest House", location: "Badrinath", costRange: "Check BKTC current tariff", bookingInfo: "BKTC guest-house accommodation." },
      { type: "GMVN / Private Hotel", location: "Badrinath town", costRange: "Seasonal tariff varies", bookingInfo: "Book early during peak season." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Paid/limited luggage-storage services available in Badrinath town.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear storage available near temple approach.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available in temple-town area.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available near parking/temple-town areas.", isAvailable: true },
      { name: "Restaurants / Food", description: "Vegetarian restaurants and shops operate along the approach.", isAvailable: true },
      { name: "Prasad", description: "Prasad available near the temple.", isAvailable: true },
      { name: "Medical Facility", description: "Swami Vivekanand Dharmarth Chikitsalay provides charitable medical care.", isAvailable: true }
    ],
    specialServices: [
      { name: "BKTC Puja Booking", description: "Mahabhishek, Abhishek and evening aartis are bookable through BKTC.", price: "Mahabhishek ~₹5500; Abhishek ~₹5300" },
      { name: "Tapt Kund", description: "Sacred hot-spring bathing area immediately below temple.", price: "Free" }
    ],
    nearbyPlaces: [
      { name: "Mana Village", description: "Last major village on the India-Tibet border, about 3 km beyond Badrinath." },
      { name: "Brahma Kapal", description: "Sacred riverside ritual site near the temple." },
      { name: "Vyas Gufa and Ganesh Gufa", description: "Sacred caves in Mana village." },
      { name: "Vasudhara Falls", description: "High-altitude waterfall reached beyond Mana." }
    ],
    images: { thumbnailImage: "https://api.theindia.co.in/storage/image/places/image/shree-badrinath-dham-374345.jpg" },
    management: {
      trustName: "Shri Badarinath Kedarnath Temple Committee (BKTC)",
      website: "https://badrinath-kedarnath.gov.in/",
      contactNumber: "Office: +91-7302257116; General: 0135-2741600; Badrinath: +91-8534001008"
    }
  },
  {
    slNo: "27",
    slug: "mansa-devi-haridwar",
    generalInfo: {
      templeName: "Maa Mansa Devi Temple, Haridwar",
      templeDescription: "Maa Mansa Devi Temple stands on Bilwa Parvat above Haridwar and is one of the city's important Siddha Peetha shrines. Pilgrims can reach the hilltop by foot or by the Udan Khatola ropeway from the Upper Road area. The temple is visited throughout the year but becomes particularly crowded during Navaratri, Kumbh-related pilgrimage periods and weekends. General entry is free.",
      location: "Haridwar, Uttarakhand",
      deity: "Goddess Mansa Devi",
      trekPoints: [],
      dressCode: "Modest clothing suitable for a place of worship."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Navaratri, Kumbh/Ardh Kumbh periods and weekends"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "19", low: "6" },
        { month: "Feb", high: "22", low: "9" },
        { month: "Mar", high: "27", low: "13" },
        { month: "Apr", high: "33", low: "18" },
        { month: "May", high: "36", low: "22" },
        { month: "Jun", high: "35", low: "25" },
        { month: "Jul", high: "31", low: "25" },
        { month: "Aug", high: "30", low: "24" },
        { month: "Sep", high: "30", low: "23" },
        { month: "Oct", high: "29", low: "17" },
        { month: "Nov", high: "25", low: "11" },
        { month: "Dec", high: "21", low: "7" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "05:00 AM",
        morningClose: "02:00 PM (lunch closure may apply)",
        eveningOpen: "After lunch closure",
        eveningClose: "09:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Morning Aarti", time: "Approx. 05:30 AM" }
      ]
    },
    transportation: [
      { mode: "Train", startPoint: "Haridwar Junction", endPoint: "Mansa Devi Ropeway Lower Station", distanceKm: 2.5, duration: "Approx. 10 mins", cost: "₹100-₹130 by taxi" },
      { mode: "Ropeway", startPoint: "Mansa Devi Udan Khatola Lower Station", endPoint: "Mansa Devi Temple", distanceKm: 0.54, duration: "A few minutes", cost: "Approx. ₹145 one-way" },
      { mode: "Flight", startPoint: "Jolly Grant Airport, Dehradun", endPoint: "Haridwar", distanceKm: 40, duration: "Approx. 1-1.5 hrs", cost: "N/A" }
    ],
    accommodation: [
      { type: "Hotel", location: "Ganga Lahari / Hari Ganga Niwas, Haridwar", costRange: "Verify current tariff", bookingInfo: "Approx. 0.6 km from Har Ki Pauri area." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Locker facilities available around the ropeway lower station.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear deposit available near temple entry.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available.", isAvailable: true },
      { name: "Toilets", description: "Bathrooms/toilets available around ropeway area.", isAvailable: true },
      { name: "Restaurants / Food", description: "Govindam Restaurant and vegetarian eateries in Haridwar below.", isAvailable: true },
      { name: "Prasad", description: "Prasad available near shrine.", isAvailable: true }
    ],
    specialServices: [
      { name: "Udan Khatola Ropeway", description: "Ropeway connects lower station with Bilwa Parvat.", price: "Approx. ₹145 one-way" }
    ],
    nearbyPlaces: [
      { name: "Har Ki Pauri", description: "Main sacred Ganga ghat in Haridwar, below the hill." },
      { name: "Chandi Devi Temple", description: "Major Shakti shrine on Neel Parvat across the Ganga." },
      { name: "Maya Devi Temple", description: "One of Haridwar's ancient Siddha Peetha temples." }
    ],
    images: { thumbnailImage: "https://www.indiaeasytrip.com/images/mansa-devi-temple-haridwar.jpg" },
    management: {
      trustName: "Maa Mansa Devi Temple Trust / Haridwar pilgrimage administration",
      website: "https://haridwar.nic.in/",
      contactNumber: "Ropeway operator: 1800-202-4050"
    }
  },
  {
    slNo: "28",
    slug: "har-ki-pauri",
    generalInfo: {
      templeName: "Har Ki Pauri / Ganga Aarti",
      templeDescription: "Har Ki Pauri is Haridwar's most important Ganga ghat and the principal venue for the daily Ganga Aarti organized by Shri Ganga Sabha. It is a public sacred riverfront rather than a conventional sanctum-based temple, so the ghat itself remains accessible through the day while ritual times follow sunrise and sunset. Evening aarti draws very large crowds, especially on weekends, festivals and Kumbh-related dates.",
      location: "Haridwar, Uttarakhand",
      deity: "River Ganga / Har Ki Pauri sacred ghat",
      trekPoints: [],
      dressCode: "Modest clothing recommended; use safe, secure clothing for river bathing."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Evening Ganga Aarti, festivals, Somvati Amavasya and Kumbh periods"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "19", low: "6" },
        { month: "Feb", high: "22", low: "9" },
        { month: "Mar", high: "27", low: "13" },
        { month: "Apr", high: "33", low: "18" },
        { month: "May", high: "36", low: "22" },
        { month: "Jun", high: "35", low: "25" },
        { month: "Jul", high: "31", low: "25" },
        { month: "Aug", high: "30", low: "24" },
        { month: "Sep", high: "30", low: "23" },
        { month: "Oct", high: "29", low: "17" },
        { month: "Nov", high: "25", low: "11" },
        { month: "Dec", high: "21", low: "7" }
      ]
    },
    templeTimings: {
      mandirTimings: { morningOpen: "Open throughout the day", morningClose: "N/A", eveningOpen: "Open throughout the day", eveningClose: "N/A" },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Morning Ganga Aarti", time: "Around sunrise; seasonal" },
        { name: "Evening Ganga Aarti", time: "Around sunset; seasonal (approx. 06:00-07:00 PM)" }
      ]
    },
    transportation: [
      { mode: "Train", startPoint: "Haridwar Junction", endPoint: "Har Ki Pauri", distanceKm: 2, duration: "Approx. 10 mins", cost: "N/A" },
      { mode: "Bus", startPoint: "Haridwar Bus Stand", endPoint: "Har Ki Pauri", distanceKm: 2, duration: "Approx. 10 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Hotel", location: "Ganga Lahari, directly overlooking the ghat", costRange: "Verify tariff", bookingInfo: "Close to Har Ki Pauri." }
    ],
    gates: [],
    facilities: [
      { name: "Drinking Water", description: "Public drinking-water facilities available.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available around Har Ki Pauri.", isAvailable: true },
      { name: "Restaurants / Food", description: "Satvik Appetite and vegetarian eateries on Upper Road.", isAvailable: true },
      { name: "Prasad", description: "Flowers/diyas and puja offerings available around the ghat.", isAvailable: true }
    ],
    specialServices: [
      { name: "Ganga Aarti", description: "Daily morning and evening aarti organized by Shri Ganga Sabha." },
      { name: "Ganga Snan", description: "Bathing at designated ghat areas with safety chains." }
    ],
    nearbyPlaces: [
      { name: "Mansa Devi Temple", description: "Hilltop Shakti shrine overlooking Haridwar." },
      { name: "Chandi Devi Temple", description: "Major temple on Neel Parvat." }
    ],
    images: { thumbnailImage: "https://imgcld.yatra.com/ytimages/image/upload/t_yt_blog_w_800_c_fill_g_auto_q_auto%3Agood_f_jpg/v1528691448/Haridwar098_1528690394.jpg" },
    management: {
      trustName: "Shri Ganga Sabha (Aarti) / Haridwar District Administration",
      website: "https://shrigangasabha.org/",
      contactNumber: "01334-227136; 01334-227928"
    }
  },
  {
    slNo: "29",
    slug: "shrinathji-nathdwara",
    generalInfo: {
      templeName: "Shrinathji Temple",
      templeDescription: "Shrinathji Temple in Nathdwara is a major Pushtimarg Vaishnava shrine dedicated to Krishna as Shrinathji. Worship follows the haveli tradition, with eight daily darshan periods rather than continuous all-day access. Exact darshan times change with season, festivals and the deity's daily seva, so the temple's 'Today's Darshan' schedule is the best reference.",
      location: "Nathdwara, Rajsamand, Rajasthan",
      deity: "Shrinathji (Lord Krishna)",
      trekPoints: [],
      dressCode: "Traditional/modest clothing recommended."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Annakut/Diwali, Janmashtami, Holi and major Pushtimarg utsavs"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "24", low: "10" },
        { month: "Feb", high: "27", low: "12" },
        { month: "Mar", high: "32", low: "17" },
        { month: "Apr", high: "37", low: "22" },
        { month: "May", high: "39", low: "26" },
        { month: "Jun", high: "36", low: "26" },
        { month: "Jul", high: "30", low: "24" },
        { month: "Aug", high: "29", low: "23" },
        { month: "Sep", high: "30", low: "22" },
        { month: "Oct", high: "32", low: "20" },
        { month: "Nov", high: "28", low: "16" },
        { month: "Dec", high: "25", low: "12" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "Approx. 05:00 AM (Mangla)",
        morningClose: "After Rajbhog darshan (approx. 12:30 PM)",
        eveningOpen: "Approx. 03:30 PM (Utthapan)",
        eveningClose: "Approx. 07:30 PM (Shayan)"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Mangla", time: "Approx. 05:15 AM - 06:00 AM" },
        { name: "Shringar", time: "Approx. 07:15 AM - 07:45 AM" },
        { name: "Gwal", time: "Approx. 09:15 AM - 09:30 AM" },
        { name: "Rajbhog", time: "Approx. 11:15 AM - 12:00 PM" },
        { name: "Utthapan", time: "Approx. 03:30 PM - 04:00 PM" },
        { name: "Bhog", time: "Approx. 04:45 PM - 05:15 PM" },
        { name: "Sandhya Aarti", time: "Approx. 05:30 PM - 06:00 PM" },
        { name: "Shayan", time: "Approx. 06:45 PM - 07:30 PM" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Maharana Pratap Airport, Udaipur", endPoint: "Shrinathji Temple", distanceKm: 49.9, duration: "Approx. 50-70 mins", cost: "₹1000-₹1300 by taxi" },
      { mode: "Road / Bus", startPoint: "Udaipur", endPoint: "Nathdwara", distanceKm: 44.7, duration: "Approx. 45-75 mins", cost: "₹40-₹120 by bus" }
    ],
    accommodation: [
      { type: "Temple Board Cottage", location: "New Cottage, Nathdwara", costRange: "Approx. ₹400-₹2400", bookingInfo: "Nathdwara Temple Board accommodation." },
      { type: "Agrawal Cottage", location: "Govind Chowk, very close to temple", costRange: "From approx. ₹200", bookingInfo: "Verify current tariff." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Deposit facilities available near temple approach.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear deposit available near temple entry.", isAvailable: true },
      { name: "Drinking Water", description: "Free drinking water available.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Prasadam Restaurant and pure-vegetarian eateries around Pritam Pol.", isAvailable: true },
      { name: "Prasad", description: "Pushtimarg prasad and offerings available from authorized counters.", isAvailable: true }
    ],
    specialServices: [
      { name: "Today's Darshan Schedule", description: "Check temple board schedule for daily utsav and seva timings." }
    ],
    nearbyPlaces: [
      { name: "Eklingji Temple", description: "Major Shiva temple on Udaipur-Nathdwara route." },
      { name: "Haldighati", description: "Historic battlefield and museum area near Nathdwara." }
    ],
    images: { thumbnailImage: "https://www.postoast.com/wp-content/uploads/2018/02/Shrinathji-Temple-Nathdwara-Places-Near-Udaipur.jpg" },
    management: {
      trustName: "Nathdwara Temple Board",
      website: "https://www.nathdwaratemple.org/",
      contactNumber: "02953-232482; 02953-233336"
    }
  },
  {
    slNo: "30",
    slug: "salasar-balaji",
    generalInfo: {
      templeName: "Salasar Balaji Temple",
      templeDescription: "Salasar Balaji Temple in Churu district is a major Hanuman shrine known for the bearded and moustached form of Balaji. The pilgrimage town receives large crowds throughout the year, with major surges during Chaitra and Ashwin fairs and on Hanuman-related auspicious days. The temple publishes separate summer and winter aarti schedules.",
      location: "Salasar, Churu, Rajasthan",
      deity: "Lord Hanuman (Salasar Balaji)",
      trekPoints: [],
      dressCode: "Modest traditional or formal clothing recommended."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Chaitra fair (Mar-Apr), Ashwin fair and Tuesdays/Saturdays"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "22", low: "7" },
        { month: "Feb", high: "26", low: "10" },
        { month: "Mar", high: "33", low: "15" },
        { month: "Apr", high: "38", low: "24" },
        { month: "May", high: "42", low: "28" },
        { month: "Jun", high: "42", low: "30" },
        { month: "Jul", high: "39", low: "29" },
        { month: "Aug", high: "37", low: "28" },
        { month: "Sep", high: "37", low: "26" },
        { month: "Oct", high: "36", low: "22" },
        { month: "Nov", high: "31", low: "16" },
        { month: "Dec", high: "25", low: "10" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "05:00 AM summer / 05:30 AM winter",
        morningClose: "Open through day",
        eveningOpen: "Open through day",
        eveningClose: "10:00 PM summer / 09:00 PM winter"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Mangla Aarti", time: "05:00 AM summer / 05:30 AM winter" },
        { name: "Rajbhog Aarti", time: "10:00 AM summer / 10:15 AM winter" },
        { name: "Sandhya Aarti", time: "07:30 PM summer / 06:00 PM winter" },
        { name: "Shayan Aarti", time: "10:00 PM summer / 09:00 PM winter" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Jaipur International Airport", endPoint: "Salasar Balaji Temple", distanceKm: 179.3, duration: "Approx. 2.5-3.5 hrs", cost: "₹3300-₹4000 by taxi" },
      { mode: "Train", startPoint: "Sujangarh Railway Station", endPoint: "Salasar Balaji", distanceKm: 28, duration: "Approx. 45 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Hotel", location: "Agastya Vilas Resort / Geetanjali, Salasar", costRange: "Verify current tariff", bookingInfo: "Approx. 0.3 km from temple area." },
      { type: "Dharamshala", location: "Salasar pilgrimage area", costRange: "Varies", bookingInfo: "Numerous community dharamshalas operate." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Paid cloakroom/locker services available around temple area.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear storage available.", isAvailable: true },
      { name: "Drinking Water", description: "Free drinking-water points available.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available around pilgrim facilities.", isAvailable: true },
      { name: "Restaurants / Food", description: "Kanha Pure Veg and many bhojanalayas on temple road.", isAvailable: true },
      { name: "Prasad", description: "Prasad widely available from temple-area shops.", isAvailable: true }
    ],
    specialServices: [
      { name: "Festival Mela Arrangements", description: "Chaitra/Ashwin fairs use special traffic, queue and parking plans." }
    ],
    nearbyPlaces: [
      { name: "Anjani Mata Temple", description: "Important nearby shrine associated with Salasar." },
      { name: "Khatu Shyam Ji", description: "Major pilgrimage destination in Shekhawati circuit." }
    ],
    images: { thumbnailImage: "https://static.zoomnews.com/photo/msid-109531649%2Cwidth-1280%2Cheight-720/109531649.jpg" },
    management: {
      trustName: "Shri Hanuman Seva Samiti / Salasar Balaji Administration",
      website: "https://www.salasarbalaji.org/",
      contactNumber: "+91-9602252749; 01568-252749"
    }
  },
  {
    slNo: "31",
    slug: "govind-dev-ji-jaipur",
    generalInfo: {
      templeName: "Govind Dev Ji Temple",
      templeDescription: "Govind Dev Ji Temple is a major Krishna shrine within Jaipur's City Palace complex and is especially important to the Gaudiya and Braj devotional traditions. The deity was brought from Vrindavan to Jaipur, and worship is organized around multiple daily jhanki and aarti windows rather than one continuous sanctum session. Janmashtami attracts very large crowds and special timings.",
      location: "Jaipur, Rajasthan",
      deity: "Govind Dev Ji (Lord Krishna)",
      trekPoints: [],
      dressCode: "Modest clothing appropriate for a place of worship."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Janmashtami, Holi and major Vaishnava festival days"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "22", low: "8" },
        { month: "Feb", high: "26", low: "11" },
        { month: "Mar", high: "32", low: "16" },
        { month: "Apr", high: "38", low: "22" },
        { month: "May", high: "40", low: "26" },
        { month: "Jun", high: "38", low: "28" },
        { month: "Jul", high: "33", low: "26" },
        { month: "Aug", high: "31", low: "25" },
        { month: "Sep", high: "33", low: "23" },
        { month: "Oct", high: "33", low: "20" },
        { month: "Nov", high: "28", low: "15" },
        { month: "Dec", high: "23", low: "10" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "Approx. 05:00 AM",
        morningClose: "Late morning jhanki closure (approx. 11:30 AM)",
        eveningOpen: "Afternoon jhanki (approx. 05:00 PM)",
        eveningClose: "Approx. 09:00 PM (Shayan)"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Mangala Jhanki", time: "Early morning (approx. 05:00-05:45 AM)" },
        { name: "Dhoop Jhanki", time: "Morning (approx. 07:30-08:15 AM)" },
        { name: "Shringar Jhanki", time: "Morning (approx. 09:30-10:15 AM)" },
        { name: "Rajbhog Jhanki", time: "Late morning (approx. 11:00-11:30 AM)" },
        { name: "Gwal Jhanki", time: "Afternoon (approx. 05:00-05:30 PM)" },
        { name: "Sandhya Jhanki", time: "Evening (approx. 06:15-07:00 PM)" },
        { name: "Shayan Jhanki", time: "Night (approx. 08:30-09:00 PM)" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Jaipur International Airport", endPoint: "Govind Dev Ji", distanceKm: 13, duration: "Approx. 20-35 mins", cost: "₹390-₹470 by taxi" },
      { mode: "Train", startPoint: "Jaipur Junction", endPoint: "Govind Dev Ji", distanceKm: 4, duration: "Approx. 15 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Hotel", location: "Jaipur city centre / Pink City", costRange: "Varies", bookingInfo: "Many hotels within 1-4 km." }
    ],
    gates: [],
    facilities: [
      { name: "Shoe Stand", description: "Footwear storage available near entry.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available around City Palace area.", isAvailable: true },
      { name: "Toilets", description: "Public facilities available in visitor zone.", isAvailable: true },
      { name: "Restaurants / Food", description: "Govindam Retreat and vegetarian restaurants operate close by.", isAvailable: true },
      { name: "Prasad", description: "Temple prasad available.", isAvailable: true }
    ],
    specialServices: [
      { name: "Daily Jhanki Schedule", description: "7 daily darshan windows; check temple schedule for exact times." }
    ],
    nearbyPlaces: [
      { name: "City Palace Jaipur", description: "Temple is located adjacent to City Palace." },
      { name: "Jantar Mantar", description: "UNESCO observatory beside City Palace." },
      { name: "Hawa Mahal", description: "Major Jaipur landmark about 1 km away." }
    ],
    images: { thumbnailImage: "https://upload.wikimedia.org/wikipedia/commons/5/54/Govind_Dev_Ji_Temple%2C_Jaipur%2C_20191218_1059_9091.jpg" },
    management: {
      trustName: "Thikana Mandir Shri Govind Dev Ji Maharaj",
      website: "https://govinddevji.net/",
      contactNumber: "9462647452"
    }
  },
  {
    slNo: "32",
    slug: "akshardham-delhi",
    generalInfo: {
      templeName: "Swaminarayan Akshardham, Delhi",
      templeDescription: "Swaminarayan Akshardham in Delhi is a large Hindu spiritual-cultural complex dedicated to Bhagwan Swaminarayan and the broader traditions of Indian spirituality and culture. The complex is closed on Mondays and combines free mandir darshan with separately ticketed exhibitions and the evening Sahaj Anand water show. Security is strict: mobile phones, cameras and most electronics are not permitted and must be deposited in the free cloakroom.",
      location: "New Delhi, Delhi",
      deity: "Bhagwan Swaminarayan",
      trekPoints: [],
      dressCode: "Shoulders, chest, back and upper arms covered; lower garments must extend below knees. Sarongs available onsite."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Weekends, school holidays and festival periods"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "21", low: "8" },
        { month: "Feb", high: "25", low: "11" },
        { month: "Mar", high: "31", low: "16" },
        { month: "Apr", high: "38", low: "22" },
        { month: "May", high: "40", low: "26" },
        { month: "Jun", high: "39", low: "28" },
        { month: "Jul", high: "35", low: "27" },
        { month: "Aug", high: "34", low: "26" },
        { month: "Sep", high: "34", low: "25" },
        { month: "Oct", high: "33", low: "19" },
        { month: "Nov", high: "28", low: "13" },
        { month: "Dec", high: "23", low: "9" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "10:00 AM",
        morningClose: "Open continuously",
        eveningOpen: "Open continuously",
        eveningClose: "08:00 PM (closed Monday)"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Morning Aarti", time: "10:30 AM" },
        { name: "Evening Aarti", time: "06:00 PM" }
      ]
    },
    transportation: [
      { mode: "Metro", startPoint: "Akshardham Metro Station (Blue Line)", endPoint: "Complex", distanceKm: 0.3, duration: "Approx. 5-10 mins walk", cost: "Metro fare" },
      { mode: "Flight / Taxi", startPoint: "Indira Gandhi International Airport", endPoint: "Akshardham", distanceKm: 22, duration: "Approx. 45-75 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Hotel", location: "Mayur Vihar / Connaught Place", costRange: "Varies", bookingInfo: "Check nearby hotels." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Free cloakroom for prohibited items with photo verification.", isAvailable: true, price: "Free" },
      { name: "Shoe Stand", description: "Shoe-house available near mandir entrance.", isAvailable: true },
      { name: "Mobile Phone Restrictions", description: "Mobile phones, cameras, electronics prohibited inside.", isAvailable: false },
      { name: "Drinking Water", description: "Drinking-water facilities available.", isAvailable: true },
      { name: "Toilets", description: "Restrooms available throughout visitor complex.", isAvailable: true },
      { name: "Restaurants / Food", description: "Premvati Food Court serves vegetarian food inside.", isAvailable: true },
      { name: "Wheelchair", description: "Wheelchairs available at entrance.", isAvailable: true },
      { name: "Parking", description: "Paid parking available at the complex.", isAvailable: true, price: "Paid" }
    ],
    specialServices: [
      { name: "Exhibitions", description: "Ticketed cultural exhibitions operate during visiting hours.", price: "Adult ₹260; child ₹160" },
      { name: "Sahaj Anand Water Show", description: "Evening multimedia water show after sunset.", price: "Ticketed" }
    ],
    nearbyPlaces: [
      { name: "Humayun's Tomb", description: "UNESCO site in central Delhi." },
      { name: "National Science Centre", description: "Family attraction near Pragati Maidan." }
    ],
    images: { thumbnailImage: "https://www.baps.org/Data/Sites/1/Media/GalleryImages/31106/WebImages/7.1.jpg" },
    management: {
      trustName: "BAPS Swaminarayan Sanstha",
      website: "https://akshardham.com/",
      contactNumber: "+91-11-43442344"
    }
  },
  {
    slNo: "33",
    slug: "iskcon-vrindavan",
    generalInfo: {
      templeName: "Sri Sri Krishna Balaram Mandir (ISKCON Vrindavan)",
      templeDescription: "Sri Sri Krishna Balaram Mandir in Raman Reti, Vrindavan, is the flagship ISKCON temple established by A.C. Bhaktivedanta Swami Prabhupada in 1975. The complex includes the altars of Krishna-Balaram, Radha-Shyamasundar and Gaura-Nitai, Prabhupada's samadhi, guest facilities and Govinda's vegetarian restaurant.",
      location: "Raman Reti, Vrindavan, Uttar Pradesh",
      deity: "Sri Krishna-Balaram, Radha-Shyamasundar and Gaura-Nitai",
      trekPoints: [],
      dressCode: "Traditional or modest formal clothing recommended."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Kartik, Janmashtami, Gaura Purnima, Holi and weekends"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "22", low: "8" },
        { month: "Feb", high: "26", low: "11" },
        { month: "Mar", high: "32", low: "16" },
        { month: "Apr", high: "38", low: "21" },
        { month: "May", high: "42", low: "26" },
        { month: "Jun", high: "40", low: "28" },
        { month: "Jul", high: "35", low: "27" },
        { month: "Aug", high: "33", low: "26" },
        { month: "Sep", high: "34", low: "24" },
        { month: "Oct", high: "34", low: "20" },
        { month: "Nov", high: "29", low: "15" },
        { month: "Dec", high: "24", low: "10" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "04:10 AM",
        morningClose: "01:00 PM",
        eveningOpen: "04:00 PM",
        eveningClose: "08:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Samadhi Aarti", time: "04:10 AM" },
        { name: "Mangala Aarti", time: "04:30 AM" },
        { name: "Sringar Darshan", time: "07:15 AM" },
        { name: "Guru Puja", time: "07:30 AM" },
        { name: "Raj Bhoga", time: "12:00 PM" },
        { name: "Sandhya Aarti", time: "06:30 PM" },
        { name: "Shayana Aarti", time: "08:00 PM" }
      ]
    },
    transportation: [
      { mode: "Train / Taxi", startPoint: "Mathura Junction", endPoint: "Vrindavan / ISKCON", distanceKm: 13.1, duration: "Approx. 15-30 mins", cost: "₹280-₹340 by taxi" }
    ],
    accommodation: [
      { type: "Guest House", location: "Krishna-Balaram International Guest House", costRange: "Check current tariff", bookingInfo: "Advance booking recommended." }
    ],
    gates: [],
    facilities: [
      { name: "Shoe Stand", description: "Footwear must be removed before temple halls.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available in complex.", isAvailable: true },
      { name: "Toilets", description: "Visitor/guest facilities available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Govinda's Restaurant operates on ground floor.", isAvailable: true },
      { name: "Prasad", description: "Maha-prasadam booth open daily.", isAvailable: true }
    ],
    specialServices: [
      { name: "Govinda's Restaurant", description: "Pure vegetarian meals: breakfast, lunch and dinner." },
      { name: "Daily Discourses", description: "Srimad Bhagavatam class at 08:00 AM; Bhagavad Gita at 06:00 PM." }
    ],
    nearbyPlaces: [
      { name: "Prem Mandir", description: "Modern Radha-Krishna temple about 1 km away." },
      { name: "Banke Bihari Mandir", description: "Major Vrindavan Krishna shrine." }
    ],
    images: { thumbnailImage: "https://images.brajrasik.org/5e70a6fa2f04a800619e3fd3.jpeg" },
    management: {
      trustName: "ISKCON Vrindavan",
      website: "https://iskconvrindavan.com/",
      contactNumber: "1800-202-1108; +91-9068945108"
    }
  },
  {
    slNo: "34",
    slug: "hanuman-garhi-ayodhya",
    generalInfo: {
      templeName: "Hanuman Garhi, Ayodhya",
      templeDescription: "Hanuman Garhi is one of Ayodhya's most important Hanuman temples and is traditionally visited before Ram Janmabhoomi. The hilltop-style shrine is reached by a staircase of about 76 steps and houses Bal Hanuman with Maa Anjani. It is open for long daily hours and general entry is free.",
      location: "Ayodhya, Uttar Pradesh",
      deity: "Lord Hanuman",
      trekPoints: [],
      dressCode: "Modest traditional or formal clothing recommended."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Ram Navami, Hanuman Jayanti, Deepotsav/Diwali and weekends"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "21", low: "10" },
        { month: "Feb", high: "25", low: "13" },
        { month: "Mar", high: "32", low: "17" },
        { month: "Apr", high: "37", low: "23" },
        { month: "May", high: "38", low: "26" },
        { month: "Jun", high: "36", low: "27" },
        { month: "Jul", high: "32", low: "26" },
        { month: "Aug", high: "32", low: "26" },
        { month: "Sep", high: "31", low: "25" },
        { month: "Oct", high: "31", low: "20" },
        { month: "Nov", high: "28", low: "15" },
        { month: "Dec", high: "23", low: "11" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "05:00 AM",
        morningClose: "Open continuously",
        eveningOpen: "Open continuously",
        eveningClose: "11:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Daily Aarti", time: "Multiple daily rituals from early morning" }
      ]
    },
    transportation: [
      { mode: "Train", startPoint: "Ayodhya Dham Junction", endPoint: "Hanuman Garhi", distanceKm: 1, duration: "Approx. 5-10 mins", cost: "N/A" },
      { mode: "Flight", startPoint: "Maharishi Valmiki International Airport", endPoint: "Hanuman Garhi", distanceKm: 10, duration: "Approx. 20-30 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Dharamshala / Yatri Niwas", location: "Maa Yatri Niwas, Ayodhya", costRange: "Approx. ₹899-₹1199 + taxes", bookingInfo: "About 0.85 km away." }
    ],
    gates: [],
    facilities: [
      { name: "Shoe Stand", description: "Footwear storage available near entry.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available in pilgrim zone.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available in Ayodhya pilgrimage area.", isAvailable: true },
      { name: "Restaurants / Food", description: "Shree Annapurna Rasoi and vegetarian eateries nearby.", isAvailable: true },
      { name: "Prasad", description: "Prasad available near temple.", isAvailable: true }
    ],
    specialServices: [
      { name: "Central Ayodhya E-rickshaw Access", description: "E-rickshaw shuttles operate along Ram Path." }
    ],
    nearbyPlaces: [
      { name: "Shri Ram Janmabhoomi Mandir", description: "Major pilgrimage temple in Ayodhya." },
      { name: "Ram Ki Paidi", description: "Sacred Saryu riverfront/ghat complex." },
      { name: "Kanak Bhawan", description: "Important Rama-Sita temple nearby." }
    ],
    images: { thumbnailImage: "https://images.beyondyatra.com/dest/ayodhya/places/hanuman-garhi-uttar-pradesh-india_img_2.jpg" },
    management: {
      trustName: "Hanuman Garhi Temple Administration",
      website: "https://ayodhya.nic.in/",
      contactNumber: "9936955274"
    }
  },
  {
    slNo: "35",
    slug: "vindhyavasini-temple",
    generalInfo: {
      templeName: "Maa Vindhyavasini Temple",
      templeDescription: "Maa Vindhyavasini Temple at Vindhyachal is a major Shakti shrine on the Ganga and forms the centre of the Vindhya Dham pilgrimage circuit. Devotees often combine darshan with Kali Khoh and Ashtabhuja as part of the Trikona Parikrama. The Vindhya Corridor provides modern pilgrim facilities and ropeways connect the hill shrines.",
      location: "Vindhyachal, Mirzapur, Uttar Pradesh",
      deity: "Goddess Vindhyavasini",
      trekPoints: [],
      dressCode: "Modest traditional or formal clothing recommended."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Chaitra and Sharad Navaratri"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "22", low: "9" },
        { month: "Feb", high: "27", low: "12" },
        { month: "Mar", high: "33", low: "17" },
        { month: "Apr", high: "39", low: "24" },
        { month: "May", high: "41", low: "27" },
        { month: "Jun", high: "38", low: "28" },
        { month: "Jul", high: "33", low: "27" },
        { month: "Aug", high: "33", low: "26" },
        { month: "Sep", high: "33", low: "25" },
        { month: "Oct", high: "32", low: "20" },
        { month: "Nov", high: "28", low: "14" },
        { month: "Dec", high: "24", low: "10" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "05:00 AM",
        morningClose: "12:00 PM",
        eveningOpen: "01:30 PM",
        eveningClose: "09:30 PM; night session until midnight"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Daily Aarti / Shringar", time: "Multiple daily temple rituals" }
      ]
    },
    transportation: [
      { mode: "Train", startPoint: "Vindhyachal Railway Station", endPoint: "Vindhyavasini Temple", distanceKm: 1, duration: "Approx. 5-10 mins", cost: "N/A" },
      { mode: "Flight", startPoint: "Lal Bahadur Shastri Airport, Varanasi", endPoint: "Vindhyachal", distanceKm: 75, duration: "Approx. 1.5-2.5 hrs", cost: "N/A" }
    ],
    accommodation: [
      { type: "Hotel", location: "Comfort Inn Vindhyan, approx. 0.6 km", costRange: "Verify tariff", bookingInfo: "Close to corridor." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Lockers available in Vindhya Corridor.", isAvailable: true },
      { name: "Shoe Stand", description: "Shoe counters available in corridor facilities.", isAvailable: true },
      { name: "Drinking Water", description: "RO drinking-water facilities available in corridor.", isAvailable: true },
      { name: "Toilets", description: "Washrooms available in corridor complex.", isAvailable: true },
      { name: "Restaurants / Food", description: "Vegetarian eateries and prasad shops operate throughout.", isAvailable: true },
      { name: "Prasad", description: "Mewa-laddu prasad available at authorized counters.", isAvailable: true }
    ],
    specialServices: [
      { name: "Sugam Darshan", description: "Assisted darshan with Shastri escort and prasad.", price: "Check tariff" },
      { name: "Kali Khoh Ropeway", description: "Ropeway serves Kali Khoh shrine.", price: "₹25 one-way / ₹40 return" },
      { name: "Ashtabhuja Ropeway", description: "Ropeway serves Ashtabhuja hill.", price: "₹30 one-way / ₹50 return" }
    ],
    nearbyPlaces: [
      { name: "Kali Khoh Temple", description: "Important cave-style Devi shrine in Trikona circuit." },
      { name: "Ashtabhuja Devi Temple", description: "Hilltop Devi shrine linked by ropeway." },
      { name: "Ganga Ghats, Vindhyachal", description: "Sacred bathing and aarti ghats." }
    ],
    images: { thumbnailImage: "https://thetempleguru.com/wp-content/uploads/2023/04/Vindhyavasini-temple-vindhyachal-3-1.jpg" },
    management: {
      trustName: "Vindhya Teerth Vikas Parishad",
      website: "https://vindhyatirthparishad.org/",
      contactNumber: "+91-7007264307"
    }
  },
  {
    slNo: "36",
    slug: "chintpurni-temple",
    generalInfo: {
      templeName: "Maa Chintpurni Temple",
      templeDescription: "Maa Chintpurni Temple in Una district is a major Shakti shrine dedicated to Chhinnamastika/Chintpurni Devi and is traditionally counted among the important North Indian Shakti Peeth pilgrimage sites. The temple is administered under Himachal Pradesh's temple-management system and attracts its largest crowds during Chaitra and Sharad Navaratri.",
      location: "Chintpurni, Una, Himachal Pradesh",
      deity: "Maa Chintpurni / Chhinnamastika Devi",
      trekPoints: [],
      dressCode: "Modest traditional or formal clothing recommended."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Chaitra and Sharad Navaratri; weekends"
    },
    footfall: {
      monthlyFootfalls: [
        { month: "Jan", totalYatra: "315,000" },
        { month: "Aug", totalYatra: "1,000,000" },
        { month: "Annual Total", totalYatra: "7,423,000" }
      ]
    },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "19", low: "6" },
        { month: "Feb", high: "22", low: "9" },
        { month: "Mar", high: "27", low: "13" },
        { month: "Apr", high: "33", low: "18" },
        { month: "May", high: "38", low: "22" },
        { month: "Jun", high: "37", low: "25" },
        { month: "Jul", high: "32", low: "25" },
        { month: "Aug", high: "31", low: "24" },
        { month: "Sep", high: "31", low: "22" },
        { month: "Oct", high: "29", low: "17" },
        { month: "Nov", high: "25", low: "11" },
        { month: "Dec", high: "21", low: "7" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "Approx. 04:00 AM summer / 05:30 AM winter",
        morningClose: "Open through day",
        eveningOpen: "Open through day",
        eveningClose: "Approx. 10:00 PM summer / 09:30 PM winter"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Mangal Aarti", time: "Approx. 06:00-06:30 AM" },
        { name: "Evening Aarti", time: "Evening ritual schedule" }
      ]
    },
    transportation: [
      { mode: "Train", startPoint: "Una Himachal Railway Station", endPoint: "Chintpurni Temple", distanceKm: 55, duration: "Approx. 1.5 hrs", cost: "N/A" },
      { mode: "Bus", startPoint: "Chintpurni Bus Stand", endPoint: "Temple", distanceKm: 1, duration: "Approx. 5-15 mins walk", cost: "N/A" }
    ],
    accommodation: [
      { type: "Dharamshala", location: "Chintpurni town", costRange: "Varies", bookingInfo: "Temple-town stays available." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Cloakroom available in temple-town approach.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear deposit available.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking-water points available.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Sagar Ratna and local dhabas operate.", isAvailable: true },
      { name: "Prasad", description: "Prasad available near shrine.", isAvailable: true }
    ],
    specialServices: [
      { name: "Langar", description: "Free community food services operate during busy pilgrimage periods." }
    ],
    nearbyPlaces: [
      { name: "Bharwain", description: "Main road junction for Chintpurni." },
      { name: "Jwala Ji Temple", description: "Approx. 35 km away." }
    ],
    images: { thumbnailImage: "https://d3fphkxyf5o5bm.cloudfront.net/image-resize/format%3Dwebp%2Cw%3D720/QwRY54Li1HMwD7oNfouIzfQQCm1zLceTjBkd5PB9Hu" },
    management: {
      trustName: "Maa Chintpurni Temple Trust",
      website: "https://chintpurni.nic.in/",
      contactNumber: "01976-255818"
    }
  },
  {
    slNo: "37",
    slug: "jwala-ji-temple",
    generalInfo: {
      templeName: "Jwala Ji Temple",
      templeDescription: "Jwala Ji Temple at Jawalamukhi in Kangra district is a celebrated Shakti shrine where natural eternal flames are worshipped as manifestations of the Goddess. The temple provides free langar twice daily and publishes seasonal darshan schedules.",
      location: "Jawalamukhi, Kangra, Himachal Pradesh",
      deity: "Maa Jwala / Jwalamukhi Devi",
      trekPoints: [],
      dressCode: "Modest traditional or formal clothing recommended."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Chaitra and Sharad Navaratri"
    },
    footfall: {
      monthlyFootfalls: [
        { month: "Annual Total", totalYatra: "1,670,000" }
      ]
    },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "16", low: "5" },
        { month: "Feb", high: "18", low: "7" },
        { month: "Mar", high: "23", low: "11" },
        { month: "Apr", high: "28", low: "15" },
        { month: "May", high: "32", low: "19" },
        { month: "Jun", high: "32", low: "22" },
        { month: "Jul", high: "28", low: "22" },
        { month: "Aug", high: "27", low: "21" },
        { month: "Sep", high: "27", low: "19" },
        { month: "Oct", high: "25", low: "14" },
        { month: "Nov", high: "21", low: "9" },
        { month: "Dec", high: "17", low: "6" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "04:30 AM summer / 05:00 AM winter",
        morningClose: "11:30 AM",
        eveningOpen: "12:30 PM (after Bhog)",
        eveningClose: "10:00 PM summer / 09:00 PM winter"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Mangal Aarti", time: "05:00-05:30 AM summer / 05:30-06:00 AM winter" },
        { name: "Bhog Aarti", time: "11:30 AM - 12:30 PM" },
        { name: "Evening Aarti", time: "07:00-08:00 PM summer / 06:00-07:00 PM winter" },
        { name: "Shayan Aarti", time: "09:00-09:40 PM summer / 08:00-08:40 PM winter" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Kangra Airport, Gaggal", endPoint: "Jwala Ji Temple", distanceKm: 50, duration: "Approx. 1.5 hrs", cost: "N/A" },
      { mode: "Bus", startPoint: "Jawalamukhi Bus Stand", endPoint: "Temple", distanceKm: 0.5, duration: "Approx. 5-10 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Dharamshala", location: "Jwala Ji Dharamshala, close to temple", costRange: "Varies", bookingInfo: "Pilgrim stays available." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Free/local cloakroom facilities available near shrine.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear storage available.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Free langar served twice daily.", isAvailable: true, price: "Free langar" },
      { name: "Prasad", description: "Prasad available near temple.", isAvailable: true }
    ],
    specialServices: [
      { name: "Free Langar", description: "Lunch roughly 12:30-02:30 PM and dinner roughly 06:30-08:30 PM." }
    ],
    nearbyPlaces: [
      { name: "Teda Mandir", description: "Local shrine about 2 km away." },
      { name: "Bajreshwari Devi Temple", description: "Approx. 35 km away in Kangra." }
    ],
    images: { thumbnailImage: "https://realhimachal.in/wp-content/uploads/2023/12/Jawamukhi-Temple-Jawala-Ji.jpg" },
    management: {
      trustName: "Jwala Ji Temple Administration",
      website: "https://kangratemples.hp.gov.in/",
      contactNumber: "01970-222223"
    }
  },
  {
    slNo: "38",
    slug: "naina-devi-temple",
    generalInfo: {
      templeName: "Shri Naina Devi Temple",
      templeDescription: "Shri Naina Devi Temple in Bilaspur district is a hilltop Shakti shrine overlooking the Gobind Sagar region. The Himachal Pradesh temple trust provides pilgrim facilities including accommodation, cloakroom, toilets, drinking water, community meals and medical support. Devotees can climb the hill or use the ropeway.",
      location: "Naina Devi, Bilaspur, Himachal Pradesh",
      deity: "Maa Naina Devi",
      trekPoints: [],
      dressCode: "Modest traditional or formal clothing recommended."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Chaitra/Sharad Navaratri and Shravan festival periods"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "16", low: "5" },
        { month: "Feb", high: "18", low: "7" },
        { month: "Mar", high: "23", low: "11" },
        { month: "Apr", high: "28", low: "15" },
        { month: "May", high: "32", low: "19" },
        { month: "Jun", high: "32", low: "22" },
        { month: "Jul", high: "28", low: "22" },
        { month: "Aug", high: "27", low: "21" },
        { month: "Sep", high: "27", low: "19" },
        { month: "Oct", high: "25", low: "14" },
        { month: "Nov", high: "21", low: "9" },
        { month: "Dec", high: "17", low: "6" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "Approx. 04:00 AM",
        morningClose: "Open through day",
        eveningOpen: "Open through day",
        eveningClose: "Approx. 10:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "First Aarti", time: "Approx. 04:00 AM" },
        { name: "Morning Aarti", time: "Approx. 06:00 AM" }
      ]
    },
    transportation: [
      { mode: "Train", startPoint: "Anandpur Sahib Railway Station", endPoint: "Naina Devi Temple", distanceKm: 25, duration: "Approx. 45-60 mins", cost: "N/A" },
      { mode: "Ropeway", startPoint: "Naina Devi lower station", endPoint: "Hilltop Temple", distanceKm: 0, duration: "A few minutes", cost: "Approx. ₹145 one-way / ₹200 return" }
    ],
    accommodation: [
      { type: "Temple Trust Accommodation", location: "Matri Aanchal / Matri Chhaya", costRange: "Nominal tariff", bookingInfo: "Trust operates rooms and dormitories." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Free cloakroom available near bus stand.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear storage available.", isAvailable: true },
      { name: "Drinking Water", description: "Temple trust operates water coolers.", isAvailable: true },
      { name: "Toilets", description: "Trust toilets available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Free meals provided by the trust.", isAvailable: true },
      { name: "Prasad", description: "Temple prasad available.", isAvailable: true }
    ],
    specialServices: [
      { name: "Ropeway", description: "Hill ropeway connects lower area to temple.", price: "₹145 one-way / ₹200 return" }
    ],
    nearbyPlaces: [
      { name: "Anandpur Sahib", description: "Major Sikh pilgrimage town about 25 km away." },
      { name: "Bhakra Dam", description: "Major dam and engineering landmark." }
    ],
    images: { thumbnailImage: "https://static.punjabkesari.in/multimedia/2026_3image_16_53_458710918nainadevi.jpg" },
    management: {
      trustName: "Shri Naina Devi Ji Temple Trust",
      website: "https://srinainadevi.com/",
      contactNumber: "1800-180-8069; WhatsApp: 9805252008"
    }
  }
];
